import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { Dropdown } from 'antd';
import { ChevronDown } from 'lucide-react';
import { getOperatorLabel, getOperatorsForFieldType } from '../core/operators';
import type { FieldType, FilterOperator as FilterOperatorType } from '../core/types';
import { getFilterPopupContainer } from './filter-popup-container';
import { OperatorBadge } from './OperatorBadge';

interface FilterOperatorProps {
    value: FilterOperatorType;
    fieldType: FieldType;
    customOperators?: FilterOperatorType[];
    onChange: (operator: FilterOperatorType) => void;
}

export function FilterOperator({ value, fieldType, customOperators, onChange }: FilterOperatorProps) {
    const operators = getOperatorsForFieldType(fieldType, customOperators);

    const menuItems = operators.map((op) => ({
        key: op,
        label: (
            <span className="flex items-center gap-2">
                <OperatorBadge operator={op} fieldType={fieldType} />
                <span>{getOperatorLabel(op, fieldType)}</span>
            </span>
        ),
        onClick: () => onChange(op),
    }));

    return (
        <Dropdown
            menu={{
                items: menuItems,
                className: 'filter-operator-dropdown',
            }}
            trigger={['click']}
            placement="bottomLeft"
            getPopupContainer={getFilterPopupContainer}
        >
            <Button
                type="secondary"
                size="middle"
                className="filter-operator-dropdown-button flex h-8 items-center justify-center gap-1.5 px-3"
            >
                <OperatorBadge operator={value} fieldType={fieldType} />
                <span className="text-muted-foreground text-sm">{getOperatorLabel(value, fieldType)}</span>
                <ChevronDown size={14} className="text-subtle-foreground" />
            </Button>
        </Dropdown>
    );
}
